export const FETCH_PROPERTIES_REQUEST = 'properties/FETCH_PROPERTIES_REQUEST'
export const FETCH_PROPERTIES_SUCCESS = 'properties/FETCH_PROPERTIES_SUCCESS'
export const FETCH_PROPERTIES_FAILURE = 'properties/FETCH_PROPERTIES_FAILURE'

export const FETCH_PROPERTY_REQUEST = 'properties/FETCH_PROPERTY_REQUEST'
export const FETCH_PROPERTY_SUCCESS = 'properties/FETCH_PROPERTY_SUCCESS'
export const FETCH_PROPERTY_FAILURE = 'properties/FETCH_PROPERTY_FAILURE'

export const GENERATE_PROPERTY_RDNS_REQUEST =
  'properties/GENERATE_PROPERTY_RDNS_REQUEST'
export const GENERATE_PROPERTY_RDNS_SUCCESS =
  'properties/GENERATE_PROPERTY_RDNS_SUCCESS'
export const GENERATE_PROPERTY_RDNS_FAILURE =
  'properties/GENERATE_PROPERTY_RDNS_FAILURE'

export const GENERATE_PROPERTY_COMMERCIAL_LICENSES_REQUEST =
  'properties/GENERATE_PROPERTY_COMMERCIAL_LICENSES_REQUEST'
export const GENERATE_PROPERTY_COMMERCIAL_LICENSES_SUCCESS =
  'properties/GENERATE_PROPERTY_COMMERCIAL_LICENSES_SUCCESS'
export const GENERATE_PROPERTY_COMMERCIAL_LICENSES_FAILURE =
  'properties/GENERATE_PROPERTY_COMMERCIAL_LICENSES_FAILURE'

export const UPLOAD_DOCUMENT_REQUEST = 'properties/UPLOAD_DOCUMENT_REQUEST'
export const UPLOAD_DOCUMENT_SUCCESS = 'properties/UPLOAD_DOCUMENT_SUCCESS'
export const UPLOAD_DOCUMENT_FAILURE = 'properties/UPLOAD_DOCUMENT_FAILURE'

export const DELETE_DOCUMENT_REQUEST = 'properties/DELETE_DOCUMENT_REQUEST'
export const DELETE_DOCUMENT_SUCCESS = 'properties/DELETE_DOCUMENT_SUCCESS'
export const DELETE_DOCUMENT_FAILURE = 'properties/DELETE_DOCUMENT_FAILURE'

export const DELETE_PAYMENT_REQUEST = 'properties/DELETE_PAYMENT_REQUEST'
export const DELETE_PAYMENT_SUCCESS = 'properties/DELETE_PAYMENT_SUCCESS'
export const DELETE_PAYMENT_FAILURE = 'properties/DELETE_PAYMENT_FAILURE'

export const UPDATE_PROPERTY_REQUEST = 'properties/UPDATE_PROPERTY_REQUEST'
export const UPDATE_PROPERTY_SUCCESS = 'properties/UPDATE_PROPERTY_SUCCESS'
export const UPDATE_PROPERTY_FAILURE = 'properties/UPDATE_PROPERTY_FAILURE'

export const DELETE_PROPERTY_IMAGE_REQUEST =
  'properties/DELETE_PROPERTY_IMAGE_REQUEST'
export const DELETE_PROPERTY_IMAGE_SUCCESS =
  'properties/DELETE_PROPERTY_IMAGE_SUCCESS'
export const DELETE_PROPERTY_IMAGE_FAILURE =
  'properties/DELETE_PROPERTY_IMAGE_FAILURE'

export const CREATE_PROPERTY_REQUEST = 'properties/CREATE_PROPERTY_REQUEST'
export const CREATE_PROPERTY_SUCCESS = 'properties/CREATE_PROPERTY_SUCCESS'
export const CREATE_PROPERTY_FAILURE = 'properties/CREATE_PROPERTY_FAILURE'

export const UPLOAD_PROPERTY_IMAGE_REQUEST =
  'properties/UPLOAD_PROPERTY_IMAGE_REQUEST'
export const UPLOAD_PROPERTY_IMAGE_SUCCESS =
  'properties/UPLOAD_PROPERTY_IMAGE_SUCCESS'
export const UPLOAD_PROPERTY_IMAGE_FAILURE =
  'properties/UPLOAD_PROPERTY_IMAGE_FAILURE'

export const FETCH_ACTIVE_FORM_REQUEST = 'properties/FETCH_ACTIVE_FORM_REQUEST'
export const FETCH_ACTIVE_FORM_SUCCESS = 'properties/FETCH_ACTIVE_FORM_SUCCESS'
export const FETCH_ACTIVE_FORM_FAILURE = 'properties/FETCH_ACTIVE_FORM_FAILURE'

export const FETCH_PROPERTY_SETTINGS_REQUEST =
  'properties/FETCH_PROPERTY_SETTINGS_REQUEST'
export const FETCH_PROPERTY_SETTINGS_SUCCESS =
  'properties/FETCH_PROPERTY_SETTINGS_SUCCESS'
export const FETCH_PROPERTY_SETTINGS_FAILURE =
  'properties/FETCH_PROPERTY_SETTINGS_FAILURE'

export const CREATE_PROPERTY_PAYMENT_REQUEST =
  'properties/CREATE_PROPERTY_PAYMENT_REQUEST'
export const CREATE_PROPERTY_PAYMENT_SUCCESS =
  'properties/CREATE_PROPERTY_PAYMENT_SUCCESS'
export const CREATE_PROPERTY_PAYMENT_FAILURE =
  'properties/CREATE_PROPERTY_PAYMENT_FAILURE'

export const UPDATE_PROPERTY_PAYMENT_REQUEST =
  'properties/UPDATE_PROPERTY_PAYMENT_REQUEST'
export const UPDATE_PROPERTY_PAYMENT_SUCCESS =
  'properties/UPDATE_PROPERTY_PAYMENT_SUCCESS'
export const UPDATE_PROPERTY_PAYMENT_FAILURE =
  'properties/UPDATE_PROPERTY_PAYMENT_FAILURE'

export const CALCULATE_FEATURES_REQUEST =
  'properties/CALCULATE_FEATURES_REQUEST'
export const CALCULATE_FEATURES_SUCCESS =
  'properties/CALCULATE_FEATURES_SUCCESS'
export const CALCULATE_FEATURES_FAILURE =
  'properties/CALCULATE_FEATURES_FAILURE'

export const DOWNLOAD_PROPERTY_DOCUMENT_REQUEST =
  'properties/DOWNLOAD_PROPERTY_DOCUMENT_REQUEST'
export const DOWNLOAD_PROPERTY_DOCUMENT_SUCCESS =
  'properties/DOWNLOAD_PROPERTY_DOCUMENT_SUCCESS'
export const DOWNLOAD_PROPERTY_DOCUMENT_FAILURE =
  'properties/DOWNLOAD_PROPERTY_DOCUMENT_FAILURE'

export const GENERATE_PROPERTY_DOCUMENT_REQUEST =
  'properties/GENERATE_PROPERTY_DOCUMENT_REQUEST'
export const GENERATE_PROPERTY_DOCUMENT_SUCCESS =
  'properties/GENERATE_PROPERTY_DOCUMENT_SUCCESS'
export const GENERATE_PROPERTY_DOCUMENT_FAILURE =
  'properties/GENERATE_PROPERTY_DOCUMENT_FAILURE'

export const DOWNLOAD_PAYMENT_RECEIPT_REQUEST =
  'properties/DOWNLOAD_PAYMENT_RECEIPT_REQUEST'
export const DOWNLOAD_PAYMENT_RECEIPT_SUCCESS =
  'properties/DOWNLOAD_PAYMENT_RECEIPT_SUCCESS'
export const DOWNLOAD_PAYMENT_RECEIPT_FAILURE =
  'properties/DOWNLOAD_PAYMENT_RECEIPT_FAILURE'

export const GENERATE_PAYMENT_REPORT_REQUEST =
  'properties/GENERATE_PAYMENT_REPORT_REQUEST'
export const GENERATE_PAYMENT_REPORT_SUCCESS =
  'properties/GENERATE_PAYMENT_REPORT_SUCCESS'
export const GENERATE_PAYMENT_REPORT_FAILURE =
  'properties/GENERATE_PAYMENT_REPORT_FAILURE'

export const GENERATE_PAYMENT_TAXPAYER_REPORT_REQUEST =
  'properties/GENERATE_PAYMENT_TAXPAYER_REPORT_REQUEST'
export const GENERATE_PAYMENT_TAXPAYER_REPORT_SUCCESS =
  'properties/GENERATE_PAYMENT_TAXPAYER_REPORT_SUCCESS'
export const GENERATE_PAYMENT_TAXPAYER_REPORT_FAILURE =
  'properties/GENERATE_PAYMENT_TAXPAYER_REPORT_FAILURE'

export const GENERATE_BUSINESS_LICENCE_REPORT_REQUEST =
  'properties/GENERATE_BUSINESS_LICENCE_REPORT_REQUEST'
export const GENERATE_BUSINESS_LICENCE_REPORT_SUCCESS =
  'properties/GENERATE_BUSINESS_LICENCE_REPORT_SUCCESS'
export const GENERATE_BUSINESS_LICENCE_REPORT_FAILURE =
  'properties/GENERATE_BUSINESS_LICENCE_REPORT_FAILURE'

export const GENERATE_PROPERTY_REPORT_REQUEST =
  'properties/GENERATE_PROPERTY_REPORT_REQUEST'
export const GENERATE_PROPERTY_REPORT_SUCCESS =
  'properties/GENERATE_PROPERTY_REPORT_SUCCESS'
export const GENERATE_PROPERTY_REPORT_FAILURE =
  'properties/GENERATE_PROPERTY_REPORT_FAILURE'

export const GENERATE_PROPERTY_BUSINESS_REPORT_REQUEST =
  'properties/GENERATE_PROPERTY_BUSINESS_REPORT_REQUEST'
export const GENERATE_PROPERTY_BUSINESS_REPORT_SUCCESS =
  'properties/GENERATE_PROPERTY_BUSINESS_REPORT_SUCCESS'
export const GENERATE_PROPERTY_BUSINESS_REPORT_FAILURE =
  'properties/GENERATE_PROPERTY_BUSINESS_REPORT_FAILURE'

export const SET_PROPERTY_FIELD_VISIT_REQUEST =
  'properties/SET_PROPERTY_FIELD_VISIT_REQUEST'
export const SET_PROPERTY_FIELD_VISIT_SUCCESS =
  'properties/SET_PROPERTY_FIELD_VISIT_SUCCESS'
export const SET_PROPERTY_FIELD_VISIT_FAILURE =
  'properties/SET_PROPERTY_FIELD_VISIT_FAILURE'

export const UPDATE_FIELD = 'properties/UPDATE_FIELD'
export const SET_DEFAULT_DATA = 'properties/SET_DEFAULT_DATA'

export const FETCH_PROPERTY_PAYMENTS_REQUEST =
  'properties/FETCH_PROPERTY_PAYMENTS_REQUEST'
export const FETCH_PROPERTY_PAYMENTS_SUCCESS =
  'properties/FETCH_PROPERTY_PAYMENTS_SUCCESS'
export const FETCH_PROPERTY_PAYMENTS_FAILURE =
  'properties/FETCH_PROPERTY_PAYMENTS_FAILURE'

export const FETCH_PROPERTY_DOCUMENTS_REQUEST =
  'properties/FETCH_PROPERTY_DOCUMENTS_REQUEST'
export const FETCH_PROPERTY_DOCUMENTS_SUCCESS =
  'properties/FETCH_PROPERTY_DOCUMENTS_SUCCESS'
export const FETCH_PROPERTY_DOCUMENTS_FAILURE =
  'properties/FETCH_PROPERTY_DOCUMENTS_FAILURE'

export const FETCH_PROPERTY_BUSINESSES_REQUEST =
  'properties/FETCH_PROPERTY_BUSINESSES_REQUEST'
export const FETCH_PROPERTY_BUSINESSES_SUCCESS =
  'properties/FETCH_PROPERTY_BUSINESSES_SUCCESS'
export const FETCH_PROPERTY_BUSINESSES_FAILURE =
  'properties/FETCH_PROPERTY_BUSINESSES_FAILURE'

export const DELETE_PROPERTY_PAYMENT_REQUEST =
  'properties/DELETE_PROPERTY_PAYMENT_REQUEST'
export const DELETE_PROPERTY_PAYMENT_SUCCESS =
  'properties/DELETE_PROPERTY_PAYMENT_SUCCESS'
export const DELETE_PROPERTY_PAYMENT_FAILURE =
  'properties/DELETE_PROPERTY_PAYMENT_FAILURE'

export const DOWNLOAD_PROPERTY_PAYMENT_REQUEST =
  'properties/DOWNLOAD_PROPERTY_PAYMENT_REQUEST'
export const DOWNLOAD_PROPERTY_PAYMENT_SUCCESS =
  'properties/DOWNLOAD_PROPERTY_PAYMENT_SUCCESS'
export const DOWNLOAD_PROPERTY_PAYMENT_FAILURE =
  'properties/DOWNLOAD_PROPERTY_PAYMENT_FAILURE'

export const FETCH_PROPERTY_DYNAMIC_FIELDS_REQUEST =
  'properties/FETCH_PROPERTY_DYNAMIC_FIELDS_REQUEST'
export const FETCH_PROPERTY_DYNAMIC_FIELDS_SUCCESS =
  'properties/FETCH_PROPERTY_DYNAMIC_FIELDS_SUCCESS'
export const FETCH_PROPERTY_DYNAMIC_FIELDS_FAILURE =
  'properties/FETCH_PROPERTY_DYNAMIC_FIELDS_FAILURE'

export const FETCH_PROPERTY_HISTORY_REQUEST =
  'properties/FETCH_PROPERTY_HISTORY_REQUEST'
export const FETCH_PROPERTY_HISTORY_SUCCESS =
  'properties/FETCH_PROPERTY_HISTORY_SUCCESS'
export const FETCH_PROPERTY_HISTORY_FAILURE =
  'properties/FETCH_PROPERTY_HISTORY_FAILURE'

export const ARCHIVE_PROPERTY_REQUEST = 'properties/ARCHIVE_PROPERTY_REQUEST'
export const ARCHIVE_PROPERTY_SUCCESS = 'properties/ARCHIVE_PROPERTY_SUCCESS'
export const ARCHIVE_PROPERTY_FAILURE = 'properties/ARCHIVE_PROPERTY_FAILURE'
